import React from "react";

export default function ContactIcon({
  href = "https://www.revolta.ai/helpdesk/customer-care-1",
  src,
  alt = "Contact us",
  width = 40,
  className = "rounded-circle",
  linkProps = {},
}) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      {...linkProps}
      className={linkProps.className}
    >
      <img src={src} alt={alt} className={className} width={width} />
    </a>
  );
}